
      // Known issue, scoped registry polyfill doesn't load as fast as oscd-shell, causing oscs-shell to fail.
      // To safeguard, we await the polyfill first, then load the rest.
      await import('@webcomponents/scoped-custom-element-registry');
      await import('../dist/oscd-shell.js');
      await import('./index.js');
    